import React from 'react';
import { ChevronUp, ChevronDown, ChevronsUpDown } from 'lucide-react';

/**
 * Drop-in replacement for <th> that supports click-to-sort.
 *
 * Props:
 *   label      – visible header text
 *   col        – data key this column sorts on
 *   sortKey    – currently active sort key (from useSortable)
 *   sortDir    – 'asc' | 'desc' (from useSortable)
 *   onSort     – callback(col) (from useSortable)
 *   align      – 'left' | 'right'  (default: 'left')
 *   className  – extra classes
 */
export function SortableTh({ label, col, sortKey, sortDir, onSort, align = 'left', className = '' }) {
  const active = sortKey === col;
  return (
    <th
      onClick={() => onSort(col)}
      className={`px-4 py-3 text-xs font-semibold uppercase tracking-wider cursor-pointer select-none
        transition-colors hover:bg-slate-100
        ${active ? 'text-indigo-700' : 'text-slate-500 hover:text-slate-800'}
        ${align === 'right' ? 'text-right' : 'text-left'}
        ${className}`}
    >
      <span className="inline-flex items-center gap-1">
        {label}
        {active
          ? (sortDir === 'asc'
              ? <ChevronUp size={11} className="text-indigo-600 flex-shrink-0" />
              : <ChevronDown size={11} className="text-indigo-600 flex-shrink-0" />)
          : <ChevronsUpDown size={11} className="text-slate-300 flex-shrink-0" />}
      </span>
    </th>
  );
}
